import styles from "../styles/StepFive.module.css";
import React, { useState, useMemo, useEffect, useRef } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";

const StepFive = ({
    setStep,
    formValues,
    setFormValues,
    distance,
    duration,
    origin,
    destination,
}) => {
    const [countryValue, setCountryValue] = useState("");
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);
    const [paymentError, setPaymentError] = useState("");
    const [errors, setErrors] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const options = useMemo(() => countryList().getData(), []);
    const promise = loadStripe(
        "pk_live_51KQwObF5DQ9njZiqQz3hBYONIEylQLx80hCe8bXosJ3rSxmxcqcrOUbfhNhXZ4p5RDszWJPsDTMoSAq9cWfIWpNj00NMjniVw1"
    );

    const [extraPrice, setExtraPrice] = useState(0);

    const paymentRef = useRef();

    useEffect(() => {
        let toPay = formValues.selectedVehicle.pricing.total;
        let totalExtra = 0;
        if (formValues.childSeatSelected) {
            const childSeatExtraPrice =
                25 * formValues.childSeatCount0_12 +
                25 * formValues.childSeatCount1_4 +
                25 * formValues.childSeatCount4_12;
            toPay = parseFloat(toPay) + childSeatExtraPrice;
            totalExtra += childSeatExtraPrice;
        }
        if (formValues.flowersSelected) {
            // Flower
            const flowersExtraPrice = 25 * formValues.flowersCount;
            toPay = parseFloat(toPay) + flowersExtraPrice;
            totalExtra += flowersExtraPrice;
        }
        if (formValues.champagneSelected) {
            // Champagne
            const champagneExtraPrice = 25 * formValues.champagneCount;
            toPay = parseFloat(toPay) + champagneExtraPrice;
            totalExtra += champagneExtraPrice;
        }
        if (formValues.weddingRibbonSelected) {
            //Wedding Ribbon
            const WeddingRibbonExtraPrice = 25 * formValues.weddingRibbonCount;
            toPay = parseFloat(toPay) + WeddingRibbonExtraPrice;
            totalExtra += WeddingRibbonExtraPrice;
        }
        setFormValues({ ...formValues, toPay: toPay.toString() });
        setExtraPrice(totalExtra);
    }, []);

    const changeHandler = (event) => {
        setCountryValue(event);
        setFormValues({ ...formValues, Country: event.label });
        if (errors.hasOwnProperty("Country")) {
            delete errors["Country"];
        }
    };

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormValues({ ...formValues, [name]: value });
        if (errors.hasOwnProperty([name])) {
            delete errors[[name]];
        }
    };

    const validateForm = () => {
        let errors = {};
        if (!formValues.BillingAddress.trim()) {
            errors.BillingAddress = "Billing Address is required";
        }
        if (!formValues.City.trim()) {
            errors.City = "City is required";
        }
        if (!formValues.PostalCode.trim()) {
            errors.PostalCode = "Postal Code is required";
        }
        if (!formValues.Country.trim()) {
            errors.Country = "Country is required";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const addBooking = () => {
        const data = {
            status: "Pending",
            transferType: formValues.serviceType,
            pickupDate: formValues.DateTime.toString(),
            vehiclePrice: formValues.selectedVehicle.pricing.total.toString(),
            toPay: formValues.toPay,
            distance: distance,
            duration: duration,
            routeFrom: origin.formatted_address,
            routeTo: destination ? destination.formatted_address : "",
            hours: formValues.hours.toString(),
            extras: {
                childSeatSelected: formValues.childSeatSelected,
                childSeatCount0_12: formValues.childSeatCount0_12,
                childSeatCount1_4: formValues.childSeatCount1_4,
                childSeatCount4_12: formValues.childSeatCount4_12,
                childSeatAge: formValues.childSeatAge,
                flowersSelected: formValues.flowersSelected,
                flowersCount: formValues.flowersCount,
                champagneSelected: formValues.champagneSelected,
                champagneCount: formValues.champagneCount,
                weddingRibbonSelected: formValues.weddingRibbonSelected,
                weddingRibbonCount: formValues.weddingRibbonCount,
            },
            clientFirstName: formValues.FirstName,
            clientLastName: formValues.LastName,
            clientEmailAddress: formValues.Email,
            clientPhoneNumber: formValues.Phone,
            passengers: parseInt(formValues.Passengers),
            suitcases: parseInt(formValues.Suitcases),
            nameBoard: formValues.NameBoard,
            flightDetails: formValues.FlightNumber,
            airlineName: formValues.AirlineName,
            flightArrivalTime: formValues.ArrivalTime,
            flightDepartureTime: formValues.DepartureTime,
            paymentMethod: "Card",
            vehicleId: formValues.selectedVehicle.sys.id,
            serviceType: formValues.type,
            returnDate: formValues.returnDateTime.toString(),
            additionalComments: formValues.AdditionalComments,
            handCarry: parseInt(formValues.HandCarry),
            sendDriverInside: formValues.sendDriverInside,
        };
        console.log(data);
        fetch(`https://api.pegasuschauffeurdrive.com/bookings`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then(({ data, errors }) => {
                if (errors) {
                    setIsDisabled(false);
                    console.error(errors);
                }
                const payload = {
                    email: formValues.Email,
                    booking_data: {
                        name: formValues.FirstName,
                        service_type: formValues.type,
                        transfer_type: formValues.serviceType,
                        date: formValues.DateTime,
                        total: parseFloat(formValues.toPay),
                        firstName: formValues.FirstName,
                        lastName: formValues.LastName,
                        distance: distance,
                        duration: duration,
                        origin_latitude: origin.geometry.location.lat(),
                        origin_longitude: origin.geometry.location.lng(),
                        origin: origin.formatted_address,
                        [formValues.type === "distance" &&
                        "destination_latitude"]:
                            formValues.type === "distance" &&
                            destination.geometry.location.lat(),
                        [formValues.type === "distance" &&
                        "destination_longitude"]:
                            formValues.type === "distance" &&
                            destination.geometry.location.lng(),
                        [formValues.type === "distance"
                            ? "destination"
                            : "hours"]:
                            formValues.type === "distance"
                                ? destination.formatted_address
                                : formValues.hours,
                        vehicle_name: formValues.selectedVehicle.name,
                        hand_carry: formValues.HandCarry,
                        suitcases: formValues.Suitcases,
                        passengers: formValues.Passengers,
                        email: formValues.Email,
                        phone: formValues.Phone,
                        nameBoard: formValues.NameBoard,
                        additional_comments: formValues.AdditionalComments,
                        [formValues.serviceType === "Round Trip" &&
                        "returnDate"]: formValues.returnDate,
                    },
                };
                fetch(`https://api.pegasuschauffeurdrive.com/send-email`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                })
                    .then((response) => response.json())
                    .then(({ data, errors }) => {
                        if (errors) {
                            setIsDisabled(false);
                            console.error(errors);
                        }
                        window.location.href =
                            "https://pegasuschauffeur.com/thank-you/";
                    });
            });
    };

    const handlePaymentBooking = async () => {
        setIsDisabled(true); // Disable the button to prevent multiple submissions

        if (!paymentSucceeded) {
            try {
                await paymentRef.current.handleSubmit(); // Wait for the payment to be processed
                setPaymentSucceeded(true); // If payment is successful, update the state
                setPaymentError(""); // Clear any payment errors
            } catch (error) {
                setPaymentError(error.message); // Handle payment errors
                setIsDisabled(false); // Re-enable the button if payment fails
                return; // Exit the function if payment fails
            }
        }

        // Now that payment is done, validate the rest of the form
        // If validation is successful, proceed to booking
        if (validateForm()) {
            addBooking();
        } else {
            setIsDisabled(false); // Re-enable the button if validation fails
        }
    };

    return (
        <div className="container pb-5">
            <nav className="container text-center">
                <img
                    className="img-fluid pt-4"
                    src="images/logo.svg"
                    alt="pegasus chauffeur"
                />
                <p className={`my-5 py-3 text-white ${styles.heading}`}>
                    Use the form below to check the pricing for our all
                    available vehicles. Smart, Secure, Online Payment System
                    designed for our valuable customers.
                </p>
            </nav>

            <img
                src="images/navigation-bar-step5.svg"
                alt="first step"
                className="img-fluid mb-5"
            />
            <div className={`${styles.box}`}>
                <h3 className={`${styles.boxHeading}`}>Add Payment Details</h3>
                <div className="row mb-5">
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>Name</label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Billing or Company Name"
                            name="CompanyName"
                            onChange={handleFormChange}
                            value={formValues.CompanyName}
                        />
                        <label className={styles.formLabel}>City</label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter City"
                            name="City"
                            onChange={handleFormChange}
                            value={formValues.City}
                        />
                        {errors.City && (
                            <span style={{ color: "red" }}>{errors.City}</span>
                        )}
                        <br />
                        <label className={styles.formLabel}>Country</label>
                        {/* <input
                            className={styles.formInput}
                            placeholder="Enter Country"
                        /> */}
                        <Select
                            className={styles.formInput}
                            options={options}
                            value={countryValue}
                            onChange={changeHandler}
                        />
                        {errors.Country && (
                            <span style={{ color: "red" }}>
                                {errors.Country}
                            </span>
                        )}
                        <br />
                        <div className="row-mt-5">
                            <div className="col">
                                <span className={styles.priceHeading}>
                                    <span style={{ fontWeight: "600" }}>
                                        Vehicel Price:
                                    </span>{" "}
                                    £
                                    {parseFloat(
                                        formValues.selectedVehicle.pricing.total
                                    ).toFixed(2)}
                                </span>
                            </div>
                            {extraPrice > 0 ? (
                                <div className="col">
                                    <span className={styles.priceHeading}>
                                        <span style={{ fontWeight: "600" }}>
                                            Extras:
                                        </span>{" "}
                                        £{extraPrice}
                                    </span>
                                </div>
                            ) : (
                                ""
                            )}
                            <hr />
                            <div className="col">
                                <span className={styles.priceHeading}>
                                    <span style={{ fontWeight: "600" }}>
                                        Acutal Price:
                                    </span>{" "}
                                    £
                                    {(
                                        parseFloat(formValues.toPay) -
                                        parseFloat(formValues.toPay) * 0.2
                                    ).toFixed(2)}
                                </span>
                            </div>
                            <div className="col">
                                <span className={styles.priceHeading}>
                                    <span style={{ fontWeight: "600" }}>
                                        VAT:
                                    </span>{" "}
                                    £
                                    {(
                                        parseFloat(formValues.toPay) * 0.2
                                    ).toFixed(2)}
                                </span>
                            </div>
                            <div className="col">
                                <span className={styles.priceHeadingFocus}>
                                    <span style={{ fontWeight: "600" }}>
                                        Total:
                                    </span>
                                    <strong> £{formValues.toPay}</strong>
                                </span>
                            </div>
                        </div>
                        <p className={styles.guarantee}>
                            Guaranteed Safe & Secure Checkout
                        </p>
                        <img
                            className="img-fluid pt-4"
                            src="images/cards-list.png"
                            alt="credit debit cards list"
                        />
                        <Elements stripe={promise}>
                            <CheckoutForm
                                formValues={formValues}
                                paymentSucceeded={paymentSucceeded}
                                setPaymentSucceeded={setPaymentSucceeded}
                                setPaymentError={setPaymentError}
                                ref={paymentRef}
                                setIsDisabled={setIsDisabled}
                            />
                        </Elements>
                        <br />
                        {paymentError && (
                            <span style={{ color: "red" }}>{paymentError}</span>
                        )}
                    </div>
                    <div className="col-lg-6">
                        <label className={styles.formLabel}>
                            Billing Address
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Billing Address"
                            name="BillingAddress"
                            onChange={handleFormChange}
                            value={formValues.BillingAddress}
                        />
                        {errors.BillingAddress && (
                            <span style={{ color: "red" }}>
                                {errors.BillingAddress}
                            </span>
                        )}
                        <br />
                        <label className={styles.formLabel}>
                            Postal/Zip Code
                        </label>
                        <input
                            className={styles.formInput}
                            placeholder="Enter Postal/Zip Code"
                            name="PostalCode"
                            onChange={handleFormChange}
                            value={formValues.PostalCode}
                        />
                        {errors.PostalCode && (
                            <span style={{ color: "red" }}>
                                {errors.PostalCode}
                            </span>
                        )}
                        <br />
                        <div className={`${styles.greyBox} p-4`}>
                            <h3 className={styles.summaryHeading}>
                                Your Journey Summary
                            </h3>
                            <hr />
                            <div className="d-flex justify-content-evenly">
                                <p className={styles.carDetail}>
                                    {formValues.selectedVehicle.name}
                                </p>
                                <img
                                    src={
                                        formValues.selectedVehicle["image"][
                                            "url"
                                        ]
                                    }
                                    alt="car"
                                    className="img-fluid"
                                    width={"40%"}
                                />
                            </div>
                            <p className={styles.summaryInfo}>
                                {" "}
                                <span className="me-3">
                                    Passenger : {formValues.Passengers}
                                </span>
                                <span>Suitcase : {formValues.Suitcases}</span>
                            </p>
                            <hr />
                            <p className={styles.summaryInfo}>
                                Name: {formValues.FirstName}{" "}
                                {formValues.LastName}
                            </p>
                            <p className={styles.summaryInfo}>
                                Phone Number: +{formValues.Phone}
                            </p>
                            <hr />
                            <p className={styles.summaryInfo}>
                                Transfer Type: {formValues.serviceType}
                            </p>
                            <p className={styles.summaryInfo}>
                                From: {origin.formatted_address}
                            </p>
                            {destination && (
                                <p className={styles.summaryInfo}>
                                    Destination: {destination.formatted_address}
                                </p>
                            )}
                            <hr />
                            <p className={styles.summaryInfo}>
                                Date & Time: {formValues.DateTime.toString()}
                            </p>
                            {formValues.returnDateTime &&
                                formValues.serviceType === "Round Trip" && (
                                    <p className={styles.summaryInfo}>
                                        Return Date & Time:{" "}
                                        {formValues.returnDateTime.toString()}
                                    </p>
                                )}
                            {/* <p className={styles.summaryInfo}>Time: 11:00 PM</p> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="row gy-3 pb-5">
                <div className="col-sm-12 col-md-6 text-center order-md-0 order-1">
                    <button
                        className={`${styles.previousBtn}`}
                        onClick={() => setStep(4)}
                    >
                        Go to Previous Page
                    </button>
                </div>
                <div className="col-sm-12 col-md-6 text-center order-md-1 order-0">
                    <button
                        className={`${styles.nextBtn}`}
                        onClick={() => handlePaymentBooking()}
                        disabled={isDisabled}
                    >
                        Pay & Book
                    </button>
                </div>
            </div>
            <div className="d-flex justify-content-center text-center pb-3"></div>
        </div>
    );
};

export default StepFive;
